var React = require('react');

function Twitter (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M512,49.25a218.64,218.64,0,0,1-60.48,16.57,104.36,104.36,0,0,0,46.18-58,210,210,0,0,1-66.56,25.41A105,105,0,0,0,249.57,105,108,108,0,0,0,252,128.93C164.74,124.67,87.52,82.85,35.65,19.14A105,105,0,0,0,67.9,159.42,103.69,103.69,0,0,1,20.48,146.5v1.15a105.43,105.43,0,0,0,84.1,103.13,104.65,104.65,0,0,1-27.52,3.46,92.77,92.77,0,0,1-19.88-1.79c13.6,41.57,52.2,72.13,98.08,73.12A210.93,210.93,0,0,1,25.12,370.34,197.72,197.72,0,0,1,0,368.9,295.54,295.54,0,0,0,161,416c193.16,0,298.76-160,298.76-298.69,0-4.64-.16-9.12-.39-13.57A209.29,209.29,0,0,0,512,49.25Z"}));
}

Twitter.defaultProps = {"viewBox":"0 0 512 416"};

module.exports = Twitter;

Twitter.default = Twitter;
